import React, { useState, useEffect } from 'react';
import AdminNavbar from '../components/AdminNavbar';
import { fetchClasses, createClass, updateClass, deleteClass } from '../utils/classesApi';
import './AdminGallery.css';

export default function AdminClasses() {
    const [classesItems, setClassesItems] = useState([]);
    
    // Form fields
    const [name, setName] = useState('');
    const [title, setTitle] = useState('');
    const [ageRange, setAgeRange] = useState('');
    const [seats, setSeats] = useState('');
    const [classTime, setClassTime] = useState('');
    const [tuitionFee, setTuitionFee] = useState('');
    
    const [editingId, setEditingId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const loadClasses = async () => {
        const data = await fetchClasses();
        setClassesItems(data || []);
    };

    useEffect(() => {
        loadClasses();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            setMessage({ type: '', text: editingId ? 'Updating class tier...' : 'Saving class tier...' });
            
            if (editingId) {
                await updateClass(editingId, { name, title, ageRange, seats, classTime, tuitionFee });
                setMessage({ type: 'success', text: 'Success! Class tier updated.' });
                setEditingId(null);
            } else {
                await createClass({ name, title, ageRange, seats, classTime, tuitionFee });
                setMessage({ type: 'success', text: 'Success! Class tier added.' });
            }
            
            setName(''); setTitle(''); setAgeRange(''); setSeats(''); setClassTime(''); setTuitionFee('');
            loadClasses();
        } catch (error) {
            setMessage({ type: 'danger', text: `Failed: ${error.message}` });
        } finally {
            setLoading(false);
        }
    }

    const handleEdit = (item) => {
        setEditingId(item.id);
        setName(item.name || '');
        setTitle(item.title || '');
        setAgeRange(item.ageRange || '');
        setSeats(item.seats || '');
        setClassTime(item.classTime || item.calssTime || '');
        setTuitionFee(item.tuitionFee || item.tutionFee || '');
    }

    const cancelEdit = () => {
        setEditingId(null);
        setName(''); setTitle(''); setAgeRange(''); setSeats(''); setClassTime(''); setTuitionFee('');
    }

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this class tier?")) return;
        try {
            await deleteClass(id);
            setMessage({ type: 'success', text: 'Class tier deleted!' });
            loadClasses();
        } catch(error) {
            setMessage({ type: 'danger', text: 'Failed to delete.' });
        }
    }

    return (
        <div className="admin-gallery-container pt-5 pb-5">
            <div className="container">
                <AdminNavbar />

                {message.text && (
                    <div className={`alert alert-${message.type} alert-dismissible fade show`} role="alert">
                        {message.text}
                        <button type="button" className="close" onClick={() => setMessage({type: '', text: ''})} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}

                <div className="row">
                    <div className="col-lg-4 mb-4">
                        <div className="admin-card upload-card">
                            <h4>{editingId ? 'Edit Class Tier' : 'Add New Class Tier'}</h4>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group mt-3">
                                    <label>Main Tier Name</label>
                                    <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Middle School" required />
                                </div>
                                <div className="form-group mt-3">
                                    <label>Subtitle / Grades</label>
                                    <input type="text" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="e.g. Grade 7 to Grade 9 & IGCSE" required />
                                </div>
                                <div className="form-group mt-3">
                                    <label>Age Range</label>
                                    <input type="text" className="form-control" value={ageRange} onChange={(e) => setAgeRange(e.target.value)} placeholder="e.g. 12 - 16" required />
                                </div>
                                <div className="form-group mt-3">
                                    <label>Total Seats</label>
                                    <input type="text" className="form-control" value={seats} onChange={(e) => setSeats(e.target.value)} placeholder="e.g. 60" required />
                                </div>
                                <div className="form-group mt-3">
                                    <label>Class Time</label>
                                    <input type="text" className="form-control" value={classTime} onChange={(e) => setClassTime(e.target.value)} placeholder="e.g. 09:00 - 15:20" required />
                                </div>
                                <div className="form-group mt-3">
                                    <label>Tuition Fee</label>
                                    <input type="text" className="form-control" value={tuitionFee} onChange={(e) => setTuitionFee(e.target.value)} placeholder="e.g. € 390 - € 500" required />
                                </div>
                                <button type="submit" className="upload-btn w-100 mt-4" disabled={loading}>
                                    {loading ? 'Saving...' : editingId ? 'Update Class Tier' : 'Add Class Tier'}
                                </button>
                                {editingId && (
                                    <button type="button" onClick={cancelEdit} className="btn btn-secondary w-100 mt-2 font-weight-bold" disabled={loading}>
                                        Cancel Edit
                                    </button>
                                )}
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-8">
                        <div className="admin-card">
                            <h4>Current Classes</h4>
                            <div className="row admin-grid mt-4">
                                {classesItems.map((item) => (
                                    <div className="col-md-6 mb-4" key={item.id}>
                                        <div className="card border-0 bg-light shadow-sm pb-2 h-100">
                                            <div className="card-body text-center p-3">
                                                <h4 className="card-title mb-0">{item.name}</h4>
                                                <p className="card-text text-muted" style={{fontSize: '0.9rem'}}>{item.title}</p>
                                            </div>
                                            <div className="card-footer bg-transparent py-3 px-4">
                                                <div className="row border-bottom">
                                                    <div className="col-6 py-1 text-right border-right"><strong>Age</strong></div>
                                                    <div className="col-6 py-1">{item.ageRange} Yrs</div>
                                                </div>
                                                <div className="row border-bottom">
                                                    <div className="col-6 py-1 text-right border-right"><strong>Seats</strong></div>
                                                    <div className="col-6 py-1">{item.seats}</div>
                                                </div>
                                                <div className="row border-bottom">
                                                    <div className="col-6 py-1 text-right border-right"><strong>Time</strong></div>
                                                    <div className="col-6 py-1" style={{fontSize: '0.8rem'}}>{item.classTime}</div>
                                                </div>
                                                <div className="row text-primary font-weight-bold">
                                                    <div className="col-6 py-1 text-right border-right"><strong>Fee</strong></div>
                                                    <div className="col-6 py-1" style={{fontSize: '0.8rem'}}>{item.tuitionFee}</div>
                                                </div>
                                            </div>
                                            <div className="p-3 pt-0 d-flex justify-content-between" style={{gap: '10px'}}>
                                                <button onClick={() => handleEdit(item)} className="btn btn-sm btn-outline-primary flex-fill">
                                                    ✏️ Edit
                                                </button>
                                                <button onClick={() => handleDelete(item.id)} className="btn btn-sm btn-outline-danger flex-fill">
                                                    🗑️ Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
